export const getAiJson =
    client =>
    (venueId, { format } = {}) =>
        client.get(`/venues/${venueId}/aiJson`, { params: { format } });

export const getAiJsonForLocale =
    client =>
    (venueId, locale, { format } = {}) =>
        client.get(`/locales/${locale}/venues/${venueId}/aiJson`, { params: { format } });
export const getBoundingBoxes =
    client =>
    (venueId, { coordinateFormat, boxFormat } = {}) =>
        client.get(`/venues/${venueId}/boundingBoxes`, { params: { coordinateFormat, boxFormat } });
export const getBoundsPolygons =
    client =>
    (venueId, { coordinateFormat } = {}) =>
        client.get(`/venues/${venueId}/boundsPolygons`, { params: { coordinateFormat } });
export const getContent =
    client =>
    (category, contentType, canonicalName, { venue, account, noExtension } = {}) =>
        client.get(`/content/${contentType}/category/${category}/${canonicalName}`, {
            params: { venue, account, noExtension },
        });
export const getFullVenueData =
    client =>
    (venueId, { accountId } = {}) =>
        client.get(`/venues/${venueId}/full`, { params: { accountId } });
export const getGeoJson = client => (venueId, levelId) => client.get(`/venues/${venueId}/geojson/${levelId}`);
export const getVenueCategories =
    client =>
    (venueId, { account } = {}) =>
        client.get(`/venues/${venueId}/categories`, { params: { account } });
export const getVenueDataObject =
    client =>
    (venueId, objectType, { format, accountId, raw } = {}) =>
        client.get(`/venues/${venueId}/objectType/${objectType}`, { params: { format, accountId, raw } });
export const listContent =
    client =>
    (category, contentType, { venue, account, full, noExtensions } = {}) =>
        client.get(`/content/${contentType}/category/${category}`, { params: { venue, account, full, noExtensions } });
export const listVenuesForAccount =
    client =>
    (accountId, { locale } = {}) =>
        client.get(`/accounts/${accountId}/venueList`, { params: { locale } });

export const listBeacons = client => venueId => client.get(`/venues/${venueId}/beacons`);
